import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Course } from "@nicsmith/shared_types";
import { courseApi } from "../api/courseApi";
import i18n from "i18next";

interface CourseState {
  courses: Course[] | null;
  loading: boolean;
  error: string | null;
}

const initialState: CourseState = {
  courses: null,
  loading: true,
  error: null,
};

const courseListSlice = createSlice({
  name: "courseList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(courseApi.endpoints.getAllCourses.matchPending, (state) => {
        state.loading = true;
        state.error = null;
        state.courses = null;
      })
      .addMatcher(
        courseApi.endpoints.getAllCourses.matchFulfilled,
        (state, action: PayloadAction<Course[]>) => {
          state.courses = action.payload;
          state.loading = false;
          state.error = null;
        }
      )
      .addMatcher(
        courseApi.endpoints.getAllCourses.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error?.message || i18n.t("errors.failedToFetchCourses", "Failed to fetch courses");
        }
      );
  },
});

export default courseListSlice.reducer;
